var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.sortedDefinitions.length > 0
    ? _c(
        "tbody",
        { staticClass: "custom-field-rows" },
        _vm._l(_vm.sortedDefinitions, function (definition) {
          return _c("tr", { key: "customField" + definition.id }, [
            _c("th", [
              _c("label", { staticClass: "label" }, [
                _vm._v("\n                " + _vm._s(definition.label)),
                definition.required
                  ? _c("span", { staticClass: "has-text-danger" }, [
                      _vm._v("*"),
                    ])
                  : _vm._e(),
                _vm._v(":\n            "),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "td",
              [
                definition.type === "text"
                  ? _c("input", {
                      staticClass: "input",
                      attrs: { type: "text" },
                      domProps: { value: _vm.value[definition.fieldKey] },
                      on: {
                        input: function ($event) {
                          return _vm.setValue(definition, $event.target.value)
                        },
                      },
                    })
                  : definition.type === "textarea"
                  ? _c("textarea", {
                      staticClass: "textarea",
                      attrs: { rows: "3" },
                      domProps: { value: _vm.value[definition.fieldKey] },
                      on: {
                        input: function ($event) {
                          return _vm.setValue(definition, $event.target.value)
                        },
                      },
                    })
                  : definition.type === "number"
                  ? _c("input", {
                      staticClass: "input",
                      attrs: { type: "number", step: "any" },
                      domProps: { value: _vm.value[definition.fieldKey] },
                      on: {
                        input: function ($event) {
                          return _vm.setValue(
                            definition,
                            $event.target.value === ""
                              ? null
                              : $event.target.value
                          )
                        },
                      },
                    })
                  : definition.type === "date"
                  ? _c("input-date", {
                      attrs: { value: _vm.value[definition.fieldKey] },
                      on: { input: (input) => _vm.setValue(definition, input) },
                    })
                  : definition.type === "boolean"
                  ? _c("label", { staticClass: "checkbox" }, [
                      _c("input", {
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: _vm.value[definition.fieldKey] === true,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.setValue(
                              definition,
                              $event.target.checked
                            )
                          },
                        },
                      }),
                    ])
                  : definition.type === "select"
                  ? _c(
                      "multiselect",
                      {
                        staticClass: "is-shorter",
                        attrs: {
                          options: definition.options || [],
                          value: _vm.value[definition.fieldKey] || null,
                          placeholder: "Auswählen",
                        },
                        on: {
                          input: (input) =>
                            _vm.setValue(definition, input || null),
                        },
                      },
                      [
                        _c("span", { attrs: { slot: "caret" }, slot: "caret" }),
                        _vm._v(" "),
                        _vm.value[definition.fieldKey]
                          ? _c("div", {
                              staticClass: "multiselect__clear",
                              attrs: { slot: "clear" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.setValue(definition, null)
                                },
                              },
                              slot: "clear",
                            })
                          : _vm._e(),
                      ]
                    )
                  : definition.type === "multiselect"
                  ? _c(
                      "multiselect",
                      {
                        staticClass: "is-shorter",
                        attrs: {
                          options: definition.options || [],
                          value: _vm.value[definition.fieldKey] || [],
                          multiple: "",
                          placeholder: "Auswählen",
                        },
                        on: {
                          input: (input) =>
                            _vm.setValue(definition, input || []),
                        },
                      },
                      [_c("span", { attrs: { slot: "caret" }, slot: "caret" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.errors && _vm.errors[definition.fieldKey]
                  ? _c("p", { staticClass: "help is-danger" }, [
                      _vm._v(_vm._s(_vm.errors[definition.fieldKey])),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ])
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }